import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=656a60d1&"
import script from "./CustomerList.vue?vue&type=script&lang=ts&"
export * from "./CustomerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports